import React, { useState, createContext } from 'react'
import Component from './Component'

// @ts-ignore
export const ChangeReferralCodeDialogContext = createContext<{
  actions: {
    open: () => void
  }
}>({
  // @ts-ignore
  actions: {}
})

export const ChangeReferralCodeDialogProvider: React.FC = ({ children }) => {
  const [open, setOpen] = useState<boolean>(false)

  const handleOpen = () => {
    setOpen(true)
  }

  return (
    <ChangeReferralCodeDialogContext.Provider
      value={{
        actions: {
          open: handleOpen
        }
      }}
    >
      {open && <Component handleClose={() => setOpen(false)} />}
      {children}
    </ChangeReferralCodeDialogContext.Provider>
  )
}
